import { Button } from "@mui/material";
import { useState } from "react";
import { useSnackbar } from "components/snackbar/SnackbarContext";
import { getDocumentFile } from "../service/CompanyDocumentsService";
import { useCompanyDocumentsLanguage } from "../i18n/CompanyDocumentsLanguageContext";

export default function DocumentActions({
  document,
  showView = true,
  downloadVariant = "text",
  getFile = getDocumentFile,
}) {
  const [loading, setLoading] = useState(false);
  const { setMessage } = useSnackbar();
  const { t } = useCompanyDocumentsLanguage();
  const openFile = async (view) => {
    const preview = view ? window.open("", "_blank") : null;
    if (preview) preview.opener = null;
    if (view && !preview) {
      setMessage({
        type: "error",
        desc: t(
          "client.documents.actions.popupBlocked",
        ),
      });
      return;
    }
    setLoading(true);
    try {
      const blob = await getFile(document.id, view ? "inline" : "attachment");
      const url = URL.createObjectURL(blob);
      if (view) preview.location.href = url;
      else {
        const link = window.document.createElement("a");
        link.href = url;
        link.download = document.stored_filename;
        link.click();
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      if (preview) preview.close();
      setMessage({ type: "error", desc: error.message });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {showView && <Button size="small" disabled={loading} onClick={() => openFile(true)}>
        {t("client.documents.actions.view")}
      </Button>}
      <Button variant={downloadVariant} size={downloadVariant === "text" ? "small" : "medium"} disabled={loading} onClick={() => openFile(false)}>
        {t("client.documents.actions.download")}
      </Button>
    </>
  );
}
